import {
  LottieAnimations,
  LottieView,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {CloseIcon, Pressable, View} from 'native-base';
import React from 'react';
import {Modal, SafeAreaView} from 'react-native';
import WebView, {WebViewProps} from 'react-native-webview';

export interface WebViewModalProps extends WebViewProps {
  showModal: boolean;
  toggleModal: () => void;
  uri: string;
  hasCloseButton?: boolean;
}

const WebViewModal: React.FC<WebViewModalProps> = props => {
  const {showModal, toggleModal, uri, hasCloseButton = false, ...rest} = props;

  const renderLoading = () => (
    <View
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      right={0}
      alignItems="center"
      justifyContent="center"
      flex={1}
      bgColor="white"
      h="100%">
      <LottieView
        source={LottieAnimations.loaderAnimation}
        style={{width: 72, height: 72}}
        loop={true}
      />
    </View>
  );

  return (
    <Modal
      transparent={false}
      style={{
        flex: 1,
        height: '100%',
      }}
      visible={showModal}>
      <SafeAreaView
        style={{
          flex: 1,
          height: '100%',
        }}>
        {hasCloseButton && (
          <View alignItems="flex-end" pr="1px">
            <Pressable
              onPress={toggleModal}
              height="20px"
              width="20px"
              justifyContent="center"
              alignItems="center"
              p="24px">
              <CloseIcon size="17px" color="tuna" />
            </Pressable>
          </View>
        )}
        <WebView
          style={{flex: 1, height: '100%'}}
          renderLoading={renderLoading}
          source={{
            uri: uri,
          }}
          {...rest}
        />
      </SafeAreaView>
    </Modal>
  );
};

export default WebViewModal;
